import React from 'react';

// Material Ui
import { useMediaQuery } from '@mui/material';

// 3D advisor avatars — green background chroma-keyed out (transparent) so they
// float on the gradient with no panel seam.
import BannerAvatars from '../../../assets/images/Home/BannerAvatarsTransparent.png';

const WelcomeBanner = ({ name, onBoardingFinished }) => {

    const matches = useMediaQuery('(min-width:650px)');

    const subtitle = onBoardingFinished
        ? 'Te damos la bienvenida a WhatsPRO'
        : matches
            ? 'Completá las tareas para hacer visible el chat en tu pagina web'
            : 'Deslizá y completá las tareas para hacer visible el chat en tu pagina web';

    return (
        <div
            data-kit=""
            className="relative mb-4 mt-4 w-full overflow-hidden rounded-lg bg-grad px-6 py-7 shadow-card sm:px-9 sm:py-9"
        >
            {/* soft decorative light — depth without noise */}
            <div className="pointer-events-none absolute -right-8 -top-24 h-64 w-64 rounded-full bg-white/10 blur-2xl" />
            <div className="pointer-events-none absolute -bottom-24 right-40 h-52 w-52 rounded-full bg-white/[0.07] blur-3xl" />
            {/* 3D advisor avatars (transparent) — float on the gradient, no seam */}
            <img
                src={BannerAvatars}
                alt=""
                aria-hidden="true"
                className="pointer-events-none absolute inset-y-0 right-5 my-auto hidden h-[82%] w-auto max-w-[46%] object-contain object-right sm:block lg:right-8"
            />
            <div className="relative z-10 max-w-2xl text-left">
                <h1 className="text-[1.6rem] font-bold leading-[1.04] tracking-[-0.03em] text-white sm:text-[2rem]">
                    ¡Hola {name}!
                </h1>
                <p className="mt-2 max-w-xl text-sm font-medium text-white/90 sm:text-[15px]">
                    {subtitle}
                </p>
            </div>
        </div>
    );
};

export default WelcomeBanner;
